import script from "./UsersGroups.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersGroups.vue?vue&type=script&setup=true&lang=js"

import "./UsersGroups.vue?vue&type=style&index=0&id=41579ea4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41579ea4"]])

export default __exports__